import { AuthClosePage } from "@/pages/authorization-management/views/auth-close-page";
import { AuthViewPage } from "@/pages/authorization-management/views/auth-view-page";
import { AuthManageStoreProvider } from "@/pages/authorization-management/store/auth-manage-store";
import { AuthEditDrawer } from "@/pages/authorization-management/components/auth-edit-drawer";
import { useAuthManageStore } from "@/pages/authorization-management/store/auth-manage-store";
import { AuthStatus } from "@/pages/authorization-management/constants/authStatus";

function AuthorizationManagementView() {
  const { authStatus } = useAuthManageStore();
  return (
    <>
      {authStatus === AuthStatus.Cancel && <AuthClosePage />}
      {authStatus !== AuthStatus.Cancel && <AuthViewPage />}
      <AuthEditDrawer isEdit={authStatus !== AuthStatus.Cancel} />
    </>
  );
}

export function AuthorizationManagement() {
  return (
    <AuthManageStoreProvider>
      <AuthorizationManagementView />
    </AuthManageStoreProvider>
  );
}
